import React from "react";
import "../../stylesheets/components/Reports/PandLReports/TransactionTable.scss";
import ReportValue from "./commonTableVal";
export const GenericTransactionTable = (props) => {
    return (React.createElement("div", { className: ` ${props === null || props === void 0 ? void 0 : props.parentClassName}` },
        React.createElement("table", null,
            React.createElement("thead", { id: "table-headings" },
                React.createElement("tr", null,
                    React.createElement("td", { className: "vTop" },
                        React.createElement("span", null, "Action")),
                    React.createElement("td", { className: "vTop" },
                        React.createElement("span", null, "Date")),
                    React.createElement("td", { className: "text-right vTop" },
                        React.createElement("span", null, "Quantity")),
                    React.createElement("td", { className: "text-right vTop" },
                        React.createElement("span", null, "Price")),
                    React.createElement("td", { className: "text-right vTop pt-0" },
                        React.createElement("span", null, "Day's Pending LTCG")),
                    React.createElement("td", null,
                        React.createElement("span", null)))),
            React.createElement("tbody", { id: "tableContent" }, props.txnList &&
                props.txnList.length > 0 &&
                props.txnList.map((x, i) => {
                    if (i > 4)
                        return;
                    return (React.createElement("tr", { key: i },
                        React.createElement("td", { className: "vTop labels" },
                            React.createElement("div", { className: "transaction-label" },
                                React.createElement("label", { className: "bought" }, x.action))),
                        React.createElement("td", { className: "vTop" },
                            React.createElement("div", { className: "text-nowrap txnDate RobotoRegular" }, x.transactionDate)),
                        React.createElement("td", { className: "vTop text-right text-nowrap" },
                            React.createElement(ReportValue, { val: x.quantity, stream: false, onlyval: false })),
                        React.createElement("td", { className: "vTop text-right text-nowrap" },
                            React.createElement(ReportValue, { val: x.price, stream: false, onlyval: false })),
                        React.createElement("td", { className: "vTop text-right text-nowrap" },
                            React.createElement(ReportValue, { val: x.daysPendingLongTerm, stream: false, onlyval: false })),
                        React.createElement("td", { className: "vTop text-right" }, x.editable && (React.createElement("span", { className: `edel-icon-edit ${!props.isMyaccount
                                ? "opacity-25 cursor_not_allowed"
                                : "hand_cursor"}`, onClick: () => {
                                if (props.isMyaccount)
                                    props.editTransaction(x);
                            } })))));
                }))),
        props.txnList.length < 1 && (React.createElement("div", { className: "d-flex justify-content-center EncodeSansN_14_400" }, "No Records found.")),
        " "));
};
